import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import {
  IFilterResponse,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { MedicalServiceSearchItem } from "src/app/model/medical-service-search-item";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { MedicalServiceService } from "src/app/services/medical-service.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";
import { LaboratoryAppointmentQuestionDialogComponent } from "../../dialogs/laboratory-appointment-question-dialog/laboratory-appointment-question-dialog.component";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";

@Component({
  selector: "app-extraccionista-search",
  templateUrl: "./extraccionista-search.component.html",
  styleUrls: ["./extraccionista-search.component.css"],
})
export class ExtraccionistaSearchComponent implements OnInit {
  loaded: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;

  displayedColumns: string[] = [
    "Disability",
    "ReceptionDate",
    "Protocol",
    "PatientDocument",
    "PatientAge",
    "PatientFullName",
    "CallerNumber",
    "Call",
    "Star",
  ];

  loading: boolean;
  dataSource = new MatTableDataSource([]);

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  set workstationSelected(value: string) {
    localStorage.setItem("workstationSelected", value);
  }

  get workstationSelected(): string {
    return localStorage.getItem("workstationSelected");
  }

  workstations: string[] = [
    "Box 1",
    "Box 2",
    "Box 3",
    "Box 4",
    "Box 5",
    "Box 6",
    "Box 7",
    "Box 8",
    "Box 9",
    "Box 10",
    "Box 11",
    "Box 12",
    "Box 13",
    "Box 14",
    "Box 15",
  ];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    private confirmDialogService: ConfirmDialogService,
    private notificationToastService: NotificationToastService,
    private authService: AuthService,
    private medicalServiceService: MedicalServiceService,
  ) {}

  ngOnInit() {}

  onStartSearch(): void {}

  async patientCall(medicalServiceSearchItem: MedicalServiceSearchItem) {
    try {
      if (this.workstationSelected != "") {
        medicalServiceSearchItem.loading = true;

        await this.medicalServiceService.patientCallValidationWorkStation(
          medicalServiceSearchItem.MedicalAppointmentId,
          this.workstationSelected,
        );

        medicalServiceSearchItem.Called = true;
        this.notificationToastService.success(
          "El paciente fue llamado",
          "Atención paciente",
        );
      } else {
        this.notificationToastService.info(
          "Debe seleccionar un BOX",
          "Atención paciente",
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente",
      );
    } finally {
      medicalServiceSearchItem.loading = false;
    }
  }

  getPatientCallButtonText(
    medicalServiceSearchItem: MedicalServiceSearchItem,
  ): string {
    return medicalServiceSearchItem.Called
      ? "Volver a llamar"
      : "Llamar paciente";
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<MedicalServiceSearchItem>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }

  canStartAttention(
    medicalServiceSearchItem: MedicalServiceSearchItem,
  ): boolean {
    return medicalServiceSearchItem.CanStartAttention;
  }

  async rollBackAttention(item: MedicalServiceSearchItem) {
    this.confirmDialogService
      .confirm("Revertir", "Esta seguro que quiere revertir", "Si", "No")
      .subscribe(async (value) => {
        if (value) {
          try {
            await this.medicalServiceService.medicalAppointmentCareRollBack(
              item,
            );
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(
              JSON.stringify(err.error),
              "Atención paciente",
            );
          }
        }
      });
  }

  async openLaboratoryAppointmentQuestionDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem,
  ) {
    const questions =
      await this.laboratoryAppointmentQuestionService.getByAppointment(
        medicalServiceSearchItem.MedicalAppointmentId,
      );

    const dialogRef = this.dialog.open(
      LaboratoryAppointmentQuestionDialogComponent,
      {
        width: "1000px",
        maxHeight: "90vh",
        disableClose: true,
        data: questions,
      },
    );
  }

  async startAttention(medicalServiceSearchItem: MedicalServiceSearchItem) {
    try {
      medicalServiceSearchItem.loading = true;
      if (this.canStartAttention(medicalServiceSearchItem)) {
        await this.medicalServiceService.medicalAppointmentCareStart(
          medicalServiceSearchItem,
        );
        this.router.navigate([
          "/extraccionista-wizard",
          medicalServiceSearchItem.MedicalAppointmentId,
          medicalServiceSearchItem.MedicalOrderId,
        ]);
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente",
      );
    } finally {
      medicalServiceSearchItem.loading = false;
    }
  }

  openMedicalAppointmentObservationDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem,
  ): void {
    this.dialog.open(MedicalAppointmenObservationDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: medicalServiceSearchItem.MedicalAppointmentId,
        editLastObservation: true,
      },
    });
  }

  logOut(): void {
    this.authService.logOut();
    this.router.navigate(["login"]);
  }
}
